import CommonApp from '../../app.js';
import {configManager} from '../../../util/config-manager/config-manager.js';
import {AddressConfigsFactory} from '../../../util/address/address-configs.js';
import {AccountConfigManager} from '../../../util/config-manager/AccountConfigManager';

CommonApp.module.service('AccountConfigManager', function() {
    return AccountConfigManager;
});
CommonApp.module.service('configManager', function() {
    return configManager;
});

CommonApp.module.directive('nsZipMask', ['configManager', 'AccountConfigManager',
    function(configManager, AccountConfigManager) {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                options: '=',
                model: '=ngModel'
            },
            link: function(scope, element, attrs, ngModelCtrl) {
                var accountConfigManager = AccountConfigManager.getConfig(configManager);
                var countryCode = accountConfigManager.site['countryCode'];
                var addressConfigs = AddressConfigsFactory.getAddressConfigs(countryCode);
                var postalCodeConfigs = addressConfigs.addressRequirements.postalCode;
                var blockedZipCodes = accountConfigManager.site['blockedZipCodes'];
                var position;
                scope.$watch('model', function() {
                    linker(scope.model, element, ngModelCtrl, countryCode, blockedZipCodes, postalCodeConfigs);
                });

                element.bind('keypress', function(event) {
                    var keyCode = event.which || event.keyCode; // get the keyCode pressed from the event.
                    var keyCodeChar = String.fromCharCode(keyCode); // determine the char from the keyCode.

                    var zipVal = this.value;
                    // if android device, test character with android keycodes
                    if (navigator.userAgent.match('Android')) {
                        // retain backspace and delete position to set back the cursor
                        if (event.which==8 || event.which==46) {
                            event.target.selectionEnd = position;
                        }
                        keyCode = this.value.charCodeAt(zipVal.length - 1);
                        keyCodeChar = String.fromCharCode(keyCode);
                    }
                    // Restrict Alphabets including both lowercase and uppercase
                    if (postalCodeConfigs.restrictAlpha) {
                        if ((keyCode >= 65 && keyCode <= 91) || (keyCode >= 97 && keyCode <= 122)) {
                            this.value = zipVal.replace(/\D/g, '');
                            return false;
                        }
                    }
                    // restrict and remove spaces
                    if (postalCodeConfigs.restrictSpaces) {
                        if (keyCode === 32) {
                            this.value = zipVal.replace(/\s/g, '');
                            return false;
                        }
                    } else {
                        // if allows spaces, restrict the spaces to one
                        if (zipCodeHasASpaceOrDash(keyCode, this.value)) {
                            this.value = zipVal.replace(/-/g, ' ');
                            this.value = zipVal.replace(/\s\s+/g, ' ');
                            return false;
                        }
                    }
                    // restrict and remove special characters
                    if (keyCodeChar) {
                        // creates a regex from the restrictedChars config
                        var specialRegex = new RegExp(postalCodeConfigs.restrictedChars);
                        var containsSpecialChar = specialRegex.test(keyCodeChar);
                        if (containsSpecialChar) {
                            this.value = zipVal.replace(specialRegex, '');
                            return false;
                        }
                    }
                    ngModelCtrl.$parsers.unshift(function(viewValue) {
                        position = event.target.selectionStart;
                        return linker(viewValue, element, ngModelCtrl, countryCode, blockedZipCodes, postalCodeConfigs);
                    });
                });
            }
        };

        // function to test if a zipCode already has a space or a dash and if the key being pressed is a space or a dash
        /**
         *
         * @param {String} keyCode
         * @param {String} zipCode
         * @return {boolean}
         */
        function zipCodeHasASpaceOrDash(keyCode, zipCode) {
            return (/[\s\-]/g.test(zipCode) && (keyCode === 32 || keyCode === 45));
        }

        // for zipcodes that are truncated at a certain place (ex. 98765-4321), this function will do so automatically
        /**
         * Truncates zipcode strings
         * @param {String} viewValue
         * @param {String} element
         * @param {Object} ngModelCtrl
         * @param {int} maxStringLength
         * @param {int} truncateStringLength
         * @param {String} separationCharacter
         * @return {*}
         */
        function truncateString(viewValue, element, ngModelCtrl, maxStringLength, truncateStringLength,
            separationCharacter) {
            var updatedValue = viewValue;
            if (viewValue && viewValue.length > truncateStringLength && viewValue.indexOf(separationCharacter) < 0) {
                updatedValue = viewValue.slice(0, truncateStringLength) + separationCharacter
                    + viewValue.slice(truncateStringLength);
                viewValue = updatedValue;
            }
            element.val(updatedValue);

            var valLength = updatedValue.length;

            // Resolving the focus shift issue in Android
            setTimeout((function(element, strLength) {
                return function() {
                    if (element.setSelectionRange !== undefined) {
                        element.setSelectionRange(strLength, strLength);
                        element.blur();
                    } else {
                        $(element).val(element.val());
                    }
                };
            }(element, valLength)), truncateStringLength);

            // Remove the separation character on delete
            if (viewValue && viewValue.length === (truncateStringLength + 1)) {
                var updatedValue = viewValue;
                if (viewValue.indexOf(separationCharacter) >= 0) {
                    updatedValue = viewValue.substr(0, viewValue.indexOf(separationCharacter));
                    viewValue = updatedValue;
                    element.val(updatedValue);
                }
            }
            return viewValue;
        }

        // function for testing zipCodes against a pattern
        /**
         * Tests zipCode entry
         * @param {String} viewValue
         * @param {String} element
         * @param {Object} ngModelCtrl
         * @param {Object} postalCodeConfigs
         * @return {String}
         */
        function testZipCodeAgainstPattern(viewValue, element, ngModelCtrl, postalCodeConfigs) {
            var patterns = postalCodeConfigs.patterns;
            var isZipCodeValid = false;
            for (var i = 0; i < patterns.length; i++) {
                var regex = new RegExp(patterns[i]);
                if (regex.test(viewValue)) {
                    isZipCodeValid = true;
                }
            }
            ngModelCtrl.$setValidity('isZipCodeValid', isZipCodeValid);
            return viewValue;
        }

        // function for testing zipCodes against blocked zip codes
        /**
         * Tests zipCode entry
         * @param {String} viewValue
         * @param {String} element
         * @param {Object} ngModelCtrl
         * @param {String} blacklist
         * @return {String}
         */
        function testZipCodeAgainstBlacklist(viewValue, element, ngModelCtrl, blacklist) {
            var isZipCodeValid = false;
            if (viewValue && blacklist.indexOf(viewValue) === -1) {
                isZipCodeValid = true;
            }
            ngModelCtrl.$setValidity('isZipCodeValid', isZipCodeValid);
            return viewValue;
        }

        // function for testing the length of the zipcode
        /**
         * Tests zipCode entry
         * @param {String} viewValue
         * @param {Object} ngModelCtrl
         * @param {Object} postalCodeConfigs
         * @return {String}
         */
        function checkZipCodeAgainstLengths(viewValue, ngModelCtrl, postalCodeConfigs) {
            var truncateZip = postalCodeConfigs.truncate;
            var minLength = postalCodeConfigs.minLength;
            var maxLength = postalCodeConfigs.maxLength;
            var isZipCodeValid = false;
            if (postalCodeConfigs.showErrorBlock1) {
                if (truncateZip) {
                    if (viewValue && (viewValue.length === minLength || viewValue.length === (maxLength - 1))) {
                        isZipCodeValid = true;
                    }
                } else {
                    if (viewValue && (viewValue.length === minLength || viewValue.length === maxLength)) {
                        isZipCodeValid = true;
                    }
                }
            } else {
                if (viewValue && viewValue.length >= minLength && viewValue.length <= maxLength) {
                    isZipCodeValid = true;
                }
            }
            ngModelCtrl.$setValidity('isZipCodeValidLength', isZipCodeValid);
            return viewValue;
        }

        /**
         *
         * @param {String} viewValue
         * @param {String} element
         * @param {Object} ngModelCtrl
         * @param {String} countryCode
         * @param {String} blockedZipCodes
         * @param {Object} postalCodeConfigs
         * @return {*}
         */
        function linker(viewValue, element, ngModelCtrl, countryCode, blockedZipCodes, postalCodeConfigs) {
            viewValue = viewValue ? viewValue : element.val();
            // remove special chars
            var specialChar = new RegExp(postalCodeConfigs.restrictedChars);
            if (specialChar) {
                viewValue = viewValue.replace(specialChar, '');
            }
            // remove other restricted chars
            var unrestrictedChars = new RegExp(postalCodeConfigs.unrestrictedChars);
            if (unrestrictedChars) {
                viewValue = viewValue.replace(unrestrictedChars, '');
            }
            // if zipcode can have spaces, restrict to only one
            if (!postalCodeConfigs.restrictSpaces) {
                viewValue = viewValue.replace(/-/g, ' '); // Remove dashes and replace with one space
                viewValue = viewValue.replace(/\s\s+/g, ' '); // Remove multiple whitespaces and replace with one space
            }
            // all invalid chars are removed, check the length
            viewValue = checkZipCodeAgainstLengths(viewValue, ngModelCtrl, postalCodeConfigs);
            // if zipcode can be truncated, call function
            if (postalCodeConfigs.truncate) {
                viewValue = truncateString(viewValue, element, ngModelCtrl, postalCodeConfigs.maxLength,
                    postalCodeConfigs.truncateLength, postalCodeConfigs.separationChar);
            }
            // if zipcode has a blacklist, call function
            if (postalCodeConfigs.blacklist) {
                viewValue = testZipCodeAgainstBlacklist(viewValue, element, ngModelCtrl, blockedZipCodes);
            }
            // if zipcode should follow a pattern, call function
            if (postalCodeConfigs.patternCheck) {
                viewValue = testZipCodeAgainstPattern(viewValue, element, ngModelCtrl, postalCodeConfigs);
            }
            return viewValue;
        }
}]);



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/directives/zip-mask/zipMask.js
// module id = 257
// module chunks = 0